import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ckEditorBroadcastMessage } from '../../models/signalR/ckEditorBroadcastMessage';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {

  constructor( private http: HttpClient) { }
  broadcastMessage(boradcastMessage :ckEditorBroadcastMessage): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('request', JSON.stringify(boradcastMessage));
    return this.http.get(`${environment.config.baseAppURL}/SignalR/GetSelfAssessmentBroadcastMessage?type=2`, { headers, responseType: 'blob' });
  }
  JoinSelfAssessmentT2Page(boradcastMessage :ckEditorBroadcastMessage): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('request', JSON.stringify(boradcastMessage));
    return this.http.get(`${environment.config.baseAppURL}/SignalR/JoinSelfAssessmentPage?type=2`, { headers, responseType: 'blob' });
  }
  LeaveSelfAssessmentT2Page(boradcastMessage :ckEditorBroadcastMessage): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('request', JSON.stringify(boradcastMessage));
    return this.http.get(`${environment.config.baseAppURL}/SignalR/LeaveSelfAssessmentPage?type=2`, { headers, responseType: 'blob' });
  }
  broadcastT3Message(boradcastMessage :ckEditorBroadcastMessage): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('request', JSON.stringify(boradcastMessage));
    return this.http.get(`${environment.config.baseAppURL}/SignalR/GetSelfAssessmentBroadcastMessage?type=3`, { headers, responseType: 'blob' });
  }
  JoinSelfAssessmentT3Page(boradcastMessage :ckEditorBroadcastMessage): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('request', JSON.stringify(boradcastMessage));
    return this.http.get(`${environment.config.baseAppURL}/SignalR/JoinSelfAssessmentPage?type=3`, { headers, responseType: 'blob' });
  }
  LeaveSelfAssessmentT3Page(boradcastMessage :ckEditorBroadcastMessage): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('request', JSON.stringify(boradcastMessage));
    return this.http.get(`${environment.config.baseAppURL}/SignalR/LeaveSelfAssessmentPage?type=3`, { headers, responseType: 'blob' });
  }
}
